import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { OrganicMobCorpse } from "./organicMobCorpse";

export class DummyMobCorpse extends OrganicMobCorpse {
	static key = "DummyMobCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): DummyMobCorpse {
		const c = new DummyMobCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
